module.exports = __webpack_public_path__ + "img/ipo-team-icon@2x.47dac46d.png";